// Firebase config is now retrieved from backend and stored in sessionStorage
// Frontend no longer has hardcoded Firebase configs
// Backend verifies token + PIN against MASTER Firebase and returns config

export const getFirebaseConfig = (token) => {
  // Get Firebase config from sessionStorage (set by login API)
  const configKey = `firebaseConfig_${token}`;
  const storedConfig = sessionStorage.getItem(configKey);
  
  if (!storedConfig) {
    console.error('❌ No Firebase config found in sessionStorage for token:', token);
    return null;
  }
  
  try {
    const config = JSON.parse(storedConfig);
    return config;
  } catch (error) {
    console.error('❌ Error parsing Firebase config from sessionStorage:', error);
    return null;
  }
};

// Store Firebase config in sessionStorage (called after successful login)
export const setFirebaseConfig = (token, config) => {
  const configKey = `firebaseConfig_${token}`;
  sessionStorage.setItem(configKey, JSON.stringify(config));
};

// Clear Firebase config from sessionStorage (called on logout)
export const clearFirebaseConfig = (token) => {
  const configKey = `firebaseConfig_${token}`;
  sessionStorage.removeItem(configKey);
};
